/**
 * Janelas reais do Painel.
 * Documenta o que cada superfície já calcula. Não unifica queries.
 */
import type { OpsTimeRange } from '../OpsCenterRibbon';

export const PERIOD_NOW = 'Agora';
export const PERIOD_LAST_7 = 'Últimos 7 dias';
export const PERIOD_LAST_14 = 'Últimos 14 dias';
export const PERIOD_LAST_30 = 'Últimos 30 dias';

export interface OpsWindowMap {
  /** Texto do filtro do ribbon. Não significa que todos os KPIs o seguem. */
  ribbonLabel: string;
  /** Heatmap e Carga: intervalo passado a getHeatmapMatrix. */
  heatmapLoad: string;
  /** Gráficos de fluxo: chartDays = max(período do filtro, 7). */
  flowCharts: string;
  /** Série financeira: max(período do filtro, 14). */
  financialSeries: string;
  /** SLA de tarefas concluídas e throughput_7d. */
  tasks7d: string;
  /** Equipe, folga, fila ativa, Andons. */
  snapshot: string;
}

export function describeOpsWindows(timeRange: OpsTimeRange): OpsWindowMap {
  if (timeRange === 'today') {
    return {
      ribbonLabel: 'Hoje',
      heatmapLoad: 'Hoje',
      flowCharts: PERIOD_LAST_7,
      financialSeries: PERIOD_LAST_14,
      tasks7d: PERIOD_LAST_7,
      snapshot: PERIOD_NOW,
    };
  }
  if (timeRange === 'last24h') {
    return {
      ribbonLabel: 'Últimas 24h',
      heatmapLoad: 'Últimas 24h',
      flowCharts: PERIOD_LAST_7,
      financialSeries: PERIOD_LAST_14,
      tasks7d: PERIOD_LAST_7,
      snapshot: PERIOD_NOW,
    };
  }
  return {
    ribbonLabel: 'Turno atual',
    heatmapLoad: PERIOD_LAST_30,
    flowCharts: PERIOD_LAST_30,
    financialSeries: PERIOD_LAST_30,
    tasks7d: PERIOD_LAST_7,
    snapshot: PERIOD_NOW,
  };
}
